import React from 'react';
import './TermsAndServices.css';

const TermsAndServices = () => {
  return (
    <div className="terms-container">
      <h1>Terms and Services Agreement</h1>
      <section>
        <h2>1. Acceptance of Terms</h2>
        <p>
          By accessing and using the services provided by EasyContainer (referred to as "Company," "we," "our," or "us"), you (referred to as "User" or "you") agree to comply with and be bound by the following terms and conditions (the "Terms"). These Terms apply to all visitors, users, and others who access or use the Service. If you do not agree to these Terms, you may not access or use the Service.
        </p>
      </section>
      <section>
        <h2>2. Services Provided</h2>
        <p>
          EasyContainer provides access to a variety of pre-designed CSS login and signup containers (the "Service"). By purchasing or using our Service, you agree to use it in accordance with these Terms.
        </p>
      </section>
      <section>
        <h2>3. User License</h2>
        <p>
          Upon purchase, the User is granted a non-exclusive, non-transferable, non-sublicensable license to use the purchased CSS login/signup container designs for personal or commercial projects. This license is limited to the User who has purchased the Service.
        </p>
      </section>
      <section>
        <h2>4. Restrictions</h2>
        <ul>
          <li>Reselling or Redistributing: You may not resell, redistribute, or share any part of the purchased designs, either in original or modified form, to any third party.</li>
          <li>Copying: You may not copy or reproduce the designs in any form, other than for backup purposes and your own use as outlined in the license.</li>
          <li>Modification for Redistribution: You may not modify the designs with the intention of reselling or redistributing the modified designs.</li>
          <li>Reverse Engineering: You may not reverse engineer, decompile, or disassemble any of the designs.</li>
        </ul>
      </section>
      <section>
        <h2>5. Intellectual Property</h2>
        <p>
          All designs, content, and materials provided by EasyContainer remain the intellectual property of the Company. Users are not granted any ownership rights to the designs beyond the limited license provided.
        </p>
      </section>
      <section>
        <h2>6. No Refund Policy</h2>
        <p>
          Due to the nature of digital products, all sales are final. Once the purchase is completed, no refunds will be issued. We encourage Users to review our product descriptions and previews carefully before making a purchase.
        </p>
      </section>
      <section>
        <h2>7. Account Termination</h2>
        <p>
          We reserve the right to terminate or suspend access to our Service immediately, without prior notice or liability, for any reason whatsoever, including without limitation if you breach the Terms. Upon termination, your right to use the Service will immediately cease.
        </p>
      </section>
      <section>
        <h2>8. Limitation of Liability</h2>
        <p>
          In no event shall EasyContainer, nor its directors, employees, partners, agents, suppliers, or affiliates, be liable for any indirect, incidental, special, consequential, or punitive damages, including without limitation, loss of profits, data, use, goodwill, or other intangible losses, resulting from (i) your use or inability to use the Service; (ii) any unauthorized access to or use of our servers and/or any personal information stored therein; (iii) any interruption or cessation of transmission to or from the Service; (iv) any bugs, viruses, trojan horses, or the like that may be transmitted to or through our Service by any third party; (v) any errors or omissions in any content or for any loss or damage incurred as a result of the use of any content posted, emailed, transmitted, or otherwise made available through the Service; and/or (vi) the defamatory, offensive, or illegal conduct of any third party. In no event shall EasyContainer's aggregate liability exceed the amounts paid by you to EasyContainer.
        </p>
      </section>
      <section>
        <h2>9. Changes to the Terms</h2>
        <p>
          We reserve the right, at our sole discretion, to modify or replace these Terms at any time. If a revision is material, we will provide at least 30 days' notice prior to any new terms taking effect. What constitutes a material change will be determined at our sole discretion. By continuing to access or use our Service after any revisions become effective, you agree to be bound by the revised terms. If you do not agree to the new terms, you are no longer authorized to use the Service.
        </p>
      </section>
      <section>
        <h2>10. Governing Law</h2>
        <p>
          These Terms shall be governed and construed in accordance with the laws of [Your Country/State], without regard to its conflict of law provisions. Our failure to enforce any right or provision of these Terms will not be considered a waiver of those rights. If any provision of these Terms is held to be invalid or unenforceable by a court, the remaining provisions of these Terms will remain in effect. These Terms constitute the entire agreement between us regarding our Service, and supersede and replace any prior agreements we might have had between us regarding the Service.
        </p>
      </section>
      <section>
        <h2>11. Contact Information</h2>
        <p>
          If you have any questions about these Terms, please contact us at [quickreactchat@gmail.com].
        </p>
      </section>
    </div>
  );
};

export default TermsAndServices;
